const VIEWS = ["Residents", "Hirers", "Network Organisations", "Volunteers", "Administrators", "Trustees", "Funders"];

export const DynamicProfileMap = () => (
  <div className="dynamic-map" data-testid="dynamic-profile-map">
    <div className="dynamic-map-hub">The Mill — Authorised Organisational Reality</div>
    <div className="dynamic-map-stem" />
    <div className="dynamic-map-bar" />
    <div className="dynamic-map-views">
      {VIEWS.map((v) => (
        <div className="dynamic-map-view" key={v}>
          <div className="dynamic-map-view-label">{v}</div>
        </div>
      ))}
    </div>
  </div>
);
